module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAAJ5JREFUOE9jZKACYASZoRh84D82s/7/Z2x4sM6+kZA9eA3Bp/k/43/HB2scD4DUkG0IAwPDgftrHRxRDLm/1gFsIDkA7hKQIbjCBp/BIH0DbwgjA8O1e2sdtClyCSPj/8Z7axwbUAKT1DBhZvinc2et01WwIQqh++wZ/zE1MDAwOBAbOzCvUJROYF6hyJC/TEzaj1bbXYMbQqwXcKkDADJwUg9+IqGsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/folder.png
// module id = 103
// module chunks = 0